import Cookies from "js-cookie";
import { APP_CONSTANTS } from "./constants";
import moment from "moment";
import {
  IDBActivityCart,
  IDBActivityCartItem,
} from "commonFnBcode/types/activityCart.types";
import {
  cartItemTypesEnum,
  TransferTypeEnum,
} from "commonFnBcode/types/dmc.types";
import _ from "lodash";
import { IActivityMarkupType } from "commonFnBcode/types/markUp";

export const getNameFromUser = (user) => {
  return user.firstName + " " + user.lastName;
  // ? user.customer
  //   ? user.customer.firstName + " " + user.customer.lastName
  //   : user.company
  //   ? user.company.companyName
  //   : user.staff
  //   ? user.staff.staffName
  //   : ""
  // : "";
};

export const getTextFromHtml = (html: string) => {
  const divContainer = document.createElement("div");
  divContainer.innerHTML = html;
  return divContainer.textContent || divContainer.innerText || "";
};

export const extendLoginSession = () => {
  const nonRemeberedExpiry = (1 / 1440) * 30; // 30 minute session

  const prevCookie = Cookies.get(APP_CONSTANTS.LOGGED_IN_COOKIE);

  if (!prevCookie || (prevCookie && prevCookie !== "remembered")) {
    // If cookie is not remembered, then extend cookie by 30min
    Cookies.set(APP_CONSTANTS.LOGGED_IN_COOKIE, "non_remembered", {
      expires: nonRemeberedExpiry,
    });
  }
};

export const getAuthToken = () => {
  const token = Cookies.get("auth-token");
  return token;
};
export const redirection401 = () => {
  // if (window.location.pathname.includes("logout")) {
  //   return;
  // }
  const urlParams = new URLSearchParams(window.location?.search);
  const redirectTo = urlParams?.get("redirectTo")
    ? "?redirectTo=" + urlParams?.get("redirectTo")
    : "";

  const redirectType = urlParams?.get("redirectType")
    ? "redirectType=" + urlParams?.get("redirectType")
    : "";
  window.location.href = `/app/logout${redirectTo}${
    redirectType ? "&" + redirectType : ""
  }`;
};

export const getDaysNights = (from, to) => {
  if (!from) return { days: 0, night: 0 };
  const days = moment(to).diff(moment(from), "days");
  return {
    days: moment(to).diff(moment(from), "days"),
    night: days - 1,
  };
};

export const filterCartItems = (cartData: IDBActivityCart | undefined) => {
  const items = [
    "transfers",
    "hotels",
    "activities",
    "miscellaneous",
    "optionalItems",
  ] as const;
  type ItemType = (typeof items)[number];

  const res = items.reduce((acc, item) => {
    acc[item] = [] as IDBActivityCartItem[];
    return acc;
  }, {} as Record<ItemType, IDBActivityCartItem[]>);
  if (!cartData) return res;

  cartData.cartItems.forEach((item) =>
    item.isOptional
      ? res.optionalItems.push(item)
      : item.itemType === cartItemTypesEnum.activity
      ? res.activities.push(item)
      : item.itemType === cartItemTypesEnum.transfer
      ? res.transfers.push(item)
      : item.itemType === cartItemTypesEnum.hotel
      ? res.hotels.push(item)
      : item.itemType === cartItemTypesEnum.miscellaneous
      ? res.miscellaneous.push(item)
      : null
  );

  return res;
};

export const getCartPrice = (
  cartData: IDBActivityCart | undefined,
  showMarkUp: boolean
) => {
  const res = {
    activitiesAmount: 0,
    hotelsAmount: 0,
    transferAmount: 0,
    miscellaneousAmount: 0,
    inclusionsAmount: 0,
    totalPrice: 0,
  };
  if (!cartData) return res;

  cartData.cartItems.forEach((item) => {
    const amt = showMarkUp
      ? item.customerTransferAmount
      : item.transferAmount || 0;

    if (item.itemType === cartItemTypesEnum.activity)
      res.activitiesAmount +=
        (showMarkUp
          ? item.customerTourOptionAmount
          : item.tourOptionAmount || 0) + amt;
    else if (item.itemType === cartItemTypesEnum.hotel)
      res.hotelsAmount +=
        (showMarkUp ? item.customerHotelAmount : item.hotelAmount || 0) + amt;
    else if (item.itemType === cartItemTypesEnum.transfer)
      res.transferAmount += amt;
    else if (item.itemType === cartItemTypesEnum.miscellaneous)
      res.miscellaneousAmount +=
        (showMarkUp
          ? item.customerMiscellaneousAmount
          : item.miscellaneousAmount || 0) + amt;
  });

  res.inclusionsAmount = res.activitiesAmount + res.miscellaneousAmount;
  res.totalPrice =
    res.activitiesAmount +
    res.hotelsAmount +
    res.transferAmount +
    res.miscellaneousAmount;
  return res;
};

/**isTwoWay emphises if the cart has more than one transfer */
export const getTransferType = (cartItem: IDBActivityCartItem) => {
  const transfers = cartItem?.transferCart?.transfers;
  const transferLength = transfers ? transfers.length : 0;
  const isReturnType = transfers
    ? transferLength > 1
      ? transfers[0]?.from.id === transfers[1]?.to.id
      : transfers[0]?.transferType === TransferTypeEnum.return
      ? true
      : false
    : false;
  return {
    isReturnType,
    isTwoWay: transferLength > 1 ? true : false,
  };
};

export const getDmcTimeString = (date, time) => {
  const dateStr = new Date(date);
  const timeStr = new Date(time);
  dateStr.setHours(timeStr.getHours());
  dateStr.setMinutes(timeStr.getMinutes());
  return dateStr.toISOString();
};
